import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import { ContentBox } from '../ContentBox';
import { ReqCompanyFirstEmployee, RespCompany } from '../../../../item/ItemCompany';
import { SingleText, SingleRedio, SingleInput, isDisableItems } from '../../Res/BaseInput';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { CancelSubmitButton, SingleButton, Swal2Button } from '../../Res/BaseButton';


export function CompanyDetail({ id, setIsLoading, isEdit }) {
  const [companyId, setCompanyId] = useState(id)
  const [mCompany, setCompany] = useState({})
  const [companyName, setCompanyName] = useState("")
  const [note, setNote] = useState("")
  const [isDisable, setisDisable] = useState("")
  const [firstEmployee, setFirstEmployee] = useState("")
  const [newFirstEmployee, setNewFirstEmployee] = useState("")

  var title = '公司資訊'
  var title_tools =
    isEdit ? <></> :
      <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => toEditPag()}>
        <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">編輯</span>
      </a>

  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleRedio title={"啟用狀態"}
              arr={isDisableItems}
              val={isDisable} action={setisDisable} />
            : <SingleText title={"啟用狀態"} val={isDisable === "" ? "" : isDisable === 1 ? "停用中" : "啟用中"} size={4} />
          }
          <SingleText title={"最近啟用日期"} val={""} size={4} />
          <SingleText title={"最近停用日期"} val={""} size={4} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleInput title={"名稱"} val={companyName} action={setCompanyName} size={4} />
            : <SingleText title={"名稱"} val={companyName} size={4} />
          }
          <SingleText title={"統編"} val={mCompany.texIdNumber} size={4} />
          {isEdit ?
            <SingleInput title={"註記"} val={note} action={setNote} size={4} />
            : <SingleText title={"註記"} val={note} size={4} />
          }
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"總員工數"} val={""} size={4} />
          <SingleText title={"啟用員工數"} val={""} size={4} />
          <SingleText title={"停用員工數"} val={""} size={4} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"登入網址"} val={window.location.origin + "/login/" + mCompany.texIdNumber} size={6} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        {firstEmployee === ""
          ?
          <div className="col-md-12">
            <SingleInput title={"第一號員工帳號"} val={newFirstEmployee} action={setNewFirstEmployee} placeholder={"09xxxxxxxx"} size={2} />
            <SingleButton title={''}  action={addFirstEmployee} name={"新增"} icon={""} size={2} />
            <SingleText title={''} val={"請務必先建立“第一個員工”，否則無法登入上列之“登入網址”。 預設登入密碼是“000000”。"} size={8} color={"danger"} />
          </div>
          :
          <div className="col-md-12">
            <SingleText title={"第一號員工帳號"} val={firstEmployee} size={2} />
            <SingleText val={""} size={2} />
            <div className="col-md-8">
              <SingleText val={"1.請以“第一個員工”登入，預設登入密碼是“000000”。預設此員工為，“管理部 ”"} size={12} color={"danger"} />
              <SingleText val={"2.預設此員工為，“管理部 經理”，並擁有“職務權限管理“的權限。"} size={12} color={"danger"} />
              <SingleText val={"3.請點選Menu列表之”職務權限管理/公司組織管理，開始設定“公司組織架構“及“職務權限”。"} size={12} color={"danger"} />
            </div>
          </div>
        }
      </div>
    </>

  var footer =
    <>
      {isEdit ?
        <div className="row m-t-sm">
          <div className="col-md-12">
            <CancelSubmitButton cancelAction={toCancel} name={"儲存"} submitAction={toEdit} isRight={true} />
          </div>
        </div>
        : <></>
      }
    </>

  useEffect(() => {
    if (id !== undefined && id !== companyId) {
      setCompanyId(id)
    }
  }, [id])

  useEffect(() => {
    if (companyId !== "") {
      getDetail()
    }
  }, [companyId])

  function getDetail() {
    setIsLoading(true)
    apiCompany.api_getCompanyDetail({
      companyId,
      success: (jsonData) => {
        var mRespCompany = new RespCompany({})
        console.log(jsonData.info)
        mRespCompany.fromJson(jsonData.info)
        console.log(mRespCompany)
        setCompany(mRespCompany)
        setCompanyName(mRespCompany.companyName)
        setNote(mRespCompany.note)
        setisDisable(mRespCompany.isDisable)
        setFirstEmployee(mRespCompany.firstEmployee)
        setIsLoading(false)
      },
      failure: (err) => {
        setIsLoading(false)
      }
    })
  }

  function toEditPag() {
    window.location.assign("/CompanyEdit/" + companyId);
  }

  function reload() {
    // console.log(window.location.href)
    window.location.assign(window.location.href);
  }

  function toCancel() {
    window.history.go(-2)
  }

  async function toEdit() {
    var mRespCompany = new RespCompany({
      companyId: companyId,
      companyName,
      note,
      isDisable
    })
    if (companyName !== "") {
      setIsLoading(true)
      apiCompany.companyEdit({
        mRespCompany,
        success: (jsonData) => {
          console.log(jsonData)
          setIsLoading(false)
          Swal2Button({
            title: "修改成功",
            cancelButtonText: "返回列表",
            cancelAction: toCancel
          })
        },
        failure: (err) => {
          console.log(err)
          setIsLoading(false)
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: '修改失敗',
          })

        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '公司名稱 不得為空',
      })
    }
  }

  function addFirstEmployee() {
    var mReqCompanyFirstEmployee = new ReqCompanyFirstEmployee({
      companyId,
      firstEmployee:newFirstEmployee
    })
    console.log(mReqCompanyFirstEmployee)
    if (newFirstEmployee !== "") {
      setIsLoading(true)
      apiCompany.addCompanyFirstEmployee({
        mReqCompanyFirstEmployee,
        success: (jsonData) => {
          console.log(jsonData)
          setIsLoading(false)
          Swal.fire({
            type: 'success',
            title: '新增成功',
          }).then(()=>{
            reload()
          })
        },
        failure: (err) => {
          console.log(err)
          setIsLoading(false)
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err||'新增失敗',
          })

        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '第一號員工帳號 不得為空',
      })
    }
  }

  return (
    <>
      <ContentBox title={title} title_tools={title_tools} content={content} footer={footer} />
      <SystemPromptInput />
    </>
  )
}

function CompanyContent({ company, isEdit }) {
  const [mCompany, setCompany] = useState({})
  const [companyName, setCompanyName] = useState("")
  const [note, setNote] = useState("")
  const [isDisable, setisDisable] = useState("")

  useEffect(() => {
    if (company !== undefined && company !== mCompany) {
      setCompany(company)
      setCompanyName(company.companyName)
      setNote(company.note)
      setisDisable(company.isDisable)
    }
  }, [company])

  async function toEdit() {
    var mRespCompany = new RespCompany({
      companyId: company.companyId,
      companyName,
      note,
      isDisable
    })
    if (companyName !== "") {
      try {
        var edit = await apiCompany.companyEdit({ mRespCompany })
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: '修改成功',
        }).then(function () {
          setCompanyName("")
          setNote("")
          //editCancel(false)
          //window.history.replace("/ManagerList");
        })
      } catch (error) {
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: '修改失敗',
        })
      }
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '公司名稱 不得為空',
      })
    }
  }

  var title_tools =
    isEdit ? <></> :
      <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => toEdit()}>
        <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">編輯</span>
      </a>

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"啟用狀態"} val={isDisable === "" ? "" : isDisable === 1 ? "停用中" : "啟用中"} size={4} />
          <SingleText title={"最近啟用日期"} val={""} size={4} />
          <SingleText title={"最近停用日期"} val={""} size={4} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"名稱"} val={companyName} size={4} />
          <SingleText title={"統編"} val={company.texIdNumber} size={4} />
          <SingleText title={"註記"} val={note} size={4} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"總員工數"} val={""} size={4} />
          <SingleText title={"啟用員工數"} val={""} size={4} />
          <SingleText title={"停用員工數"} val={""} size={4} />
        </div>
      </div>
    </>
  )
}